import React from 'react';


const Chooseus = () => {
  return (
    <>
      <div id='chooseus' className='text-center'>
        <div className='container'>
          <h2>WHY CHOOSE US</h2>
          <h3>We specialize in Water Purification Equipment. We aim to provide only the best customer service and strongly believe our customer support differentiates us from other suppliers. </h3>
          <div className="col-lg-3">
            <p ><img src="img/chooseus/ontime.png" alt="24/7-customer-support" width="200px" /></p>
            <h3>On Time Services</h3>
            <p>We value your time with prompt and efficient service. Expect timely responses and quick resolutions for your RO needs.</p>
          </div>
          <div className="col-lg-3">
            <p><img src="img/chooseus/besttech.png" alt="value for money" width="200px" /></p>
            <h3>Experience Technicians</h3>
            <p>Our skilled technicians bring years of expertise to ensure flawless RO repairs and maintenance. Trust in their professionalism and knowledge.</p>
          </div>
          <div className="col-lg-3">
            <p ><img src="img/chooseus/bestprice.png" alt="installation service" width="200px" /></p>
            <h3 >Best Transparent prices</h3>
            <p>Enjoy clear, upfront pricing with no hidden surprises. We deliver exceptional service at the most competitive rates.</p>
          </div>
          <div className="col-lg-3">
            <p><img src="img/chooseus/assured.png" alt="home service" width="200px" /></p>
            <h3>Assured service</h3>
            <p>Quality you can count on, backed by our commitment to excellence. Your RO system is in the safest hands with us.</p>
          </div>
        </div>
      </div>

    </>
  );
}

export default Chooseus;